module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-Regular.d51d1334.eot";